// src/pages/CourseTime/components/slides/assessment/FreeTextQuestion.comp.jsx
import React from 'react';
import styled from 'styled-components';
import { GET_APP_LOCALIZE_TEXT } from '../../../../../utils/dq_lc_service/lc_service';

// Styled components
const FreeTextInput = styled.textarea`
  width: 100%;
  max-width: 600px;
  min-height: 120px;
  padding: 12px;
  border: 2px solid ${props => props.borderColor || '#fe696e'};
  border-radius: 8px;
  font-size: 16px;
  font-family: "Source Sans Pro", "Helvetica Neue", sans-serif;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: ${props => props.focusColor || '#e05560'};
    box-shadow: 0 0 0 3px rgba(254, 105, 110, 0.1);
  }

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

// Free-text (OPQ) answer input.
const FreeTextQuestion = ({ slideId, currentAnswer, setAnswersMap, themeColor, pageLc }) => {
  const handleFreeTextChange = (text) => {
    setAnswersMap(prev => ({
      ...prev,
      [slideId]: text
    }));
  };

  const freeTextValue = typeof currentAnswer === 'string' ? currentAnswer : '';

  return (
    <>
      <FreeTextInput
        placeholder={GET_APP_LOCALIZE_TEXT(pageLc, 'ct__type_answer_here') + '...'}
        value={freeTextValue}
        onChange={(e) => handleFreeTextChange(e.target.value)}
        borderColor={themeColor}
        focusColor={themeColor}
      />
    </>
  );
};

export default FreeTextQuestion;
